import { formatChatMessageHtml } from "@/lib/formatChatMessageHtml";

/**
 * Renders a canned-response body as safe HTML so saved markdown links display.
 */
export class CannedResponseBodyPreview {
  /**
   * @param {string | null | undefined} body
   * @returns {string}
   */
  toHtml(body) {
    if (body == null || String(body).trim() === "") return "";
    return formatChatMessageHtml(body);
  }

  /**
   * @param {string | null | undefined} body
   * @returns {boolean}
   */
  hasContent(body) {
    return Boolean(body != null && String(body).trim());
  }
}
